import React from "react";

import { ArrowForwardIos, Check } from "@mui/icons-material";
import Close from "@mui/icons-material/Close";
import { Box, Button } from "@mui/material";

import { IconButton } from "@/components/Button";
import { Spacer } from "@/components/Spacer/Spacer";
import { HeadlineBold, Overline1 } from "@/components/Typography";
import { colors } from "@/theme/overrides/colors";

import { useBannerStyles } from "./base/styles";
import { BannerProps } from "./base/types";

export const DescriptiveBanner: React.FC<BannerProps> = ({
  title,
  message,
  buttonText,
  onClose,
  onClick,
}) => {
  const { classes } = useBannerStyles();

  return (
    <>
      <Box
        alignItems="center"
        bgcolor={colors.theme.neutral.background}
        borderRadius="8px"
        display="flex"
        py="8px"
        pl="16px"
      >
        <Box
          alignItems="center"
          bgcolor={colors.theme.neutral.lightest}
          borderRadius="50%"
          display="flex"
          justifyContent="center"
          height="48px"
          width="48px"
        >
          <Check className={classes.colorWhite} />
        </Box>
        <Spacer w={16} />
        <Box flex={1}>
          <HeadlineBold text={title} />
          <Spacer h={4} />
          <Overline1 text={message} />
        </Box>
        <Button
          color="secondary"
          endIcon={<ArrowForwardIos />}
          onClick={onClick}
        >
          {buttonText}
        </Button>
        <Spacer w={16} />
        <Box className={classes.closeButtonPosition}>
          <IconButton icon={<Close />} size="smaller" onClick={onClose} />
        </Box>
      </Box>
    </>
  );
};
